<script setup>
import { computed, onMounted } from 'vue'
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  item: Object,
})

const delayRevealInS = computed(() => props.item.properties.delayRevealInMs / 1000)

const stringDistance = computed(() => Math.round(props.item.enrichment.distanceInKm).toString().padStart(3, '0'))

const repeats = (totalDuration, animationDuration) => Math.floor(totalDuration / animationDuration)
const setRandomDigit = (element) => (element.innerText = Math.floor(Math.random() * 10))

const distanceElement = ref(null)
const digitElements = ref([])
onMounted(() => {
  const animationPartA = (index) => {
    let step = 0
    return {
      duration: 0.5,
      ease: 'steps(10)',
      onUpdate: function () {
        const currentStep = Math.floor(this.progress() * 10)
        if (currentStep !== step) {
          step = currentStep
          setRandomDigit(digitElements.value[index])
        }
      },
      repeat: repeats(delayRevealInS.value + (2 - index) * 1.1, 0.5),
    }
  }

  gsapTimeline()
    .to(digitElements.value[2], animationPartA(2))
    .to(digitElements.value[2], { textContent: stringDistance.value[2], duration: 1, snap: { textContent: 1 }, ease: 'power2.out' })
    .set(digitElements.value[2], { scale: 0.8 }, '=-0.4')
    .to(digitElements.value[2], { scale: 1.1, duration: 0.5, ease: 'bounce.out' }, '<')

  gsapTimeline()
    .to(digitElements.value[1], animationPartA(1), '<')

    .to(digitElements.value[1], { textContent: stringDistance.value[1], duration: 1, snap: { textContent: 1 }, ease: 'power2.out' })
    .set(digitElements.value[1], { scale: 0.8 }, '=-0.4')
    .to(digitElements.value[1], { scale: 1.1, duration: 0.5, ease: 'bounce.out' }, '<')

  gsapTimeline()
    .to(digitElements.value[0], animationPartA(0), '<')
    .to(digitElements.value[0], { textContent: stringDistance.value[0], duration: 1, snap: { textContent: 1 }, ease: 'power2.out' })
    .set(digitElements.value[0], { scale: 0.8 }, '=-0.4')
    .to(digitElements.value[0], { scale: 1.1, duration: 0.3, ease: 'bounce.out' }, '<')
    .to(digitElements.value, { scale: 1.2, duration: 0.6, ease: 'bounce.out' }, '=-0.1')
})
</script>

<template>
  <div
    ref="distanceElement"
    class="absolute font-cervo font-bold w-[1000px] text-white 2xl left-[50px] 5tv:left-[90px] top-[300px] 5tv:top-[660px] text-[20.5rem] 5tv:text-[36rem] flex justify-end text-center"
  >
    <div class="grid grid-cols-3">
      <div v-for="(digit, index) in stringDistance" :key="index" ref="digitElements" class="w-36 5tv:w-64" v-text="digit" />
    </div>
  </div>
</template>
